module.exports = "/images/Bumper boat.svg?e9315d7e8792c9f25b34c48fd8d54051";